// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QrJa","type":"styles_type__1xnjw","choices":"styles_choices__2jRiM"};